import { render, staticRenderFns } from "./ManageServiceLayout.vue?vue&type=template&id=2a5c84d3"
import script from "./ManageServiceLayout.vue?vue&type=script&lang=js"
export * from "./ManageServiceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports